import React from 'react';

import * as buttonConstants from '../buttonConstants';

import Button from '../Button';


function CancelButton(props) {

    return (
        <Button
            {...props}
            flavor={buttonConstants.FLAVOR_CANCEL}
        />
    );
}


CancelButton.propTypes = {...Button.propTypes};

CancelButton.defaultProps = {...Button.defaultProps};


export default CancelButton;
